import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const Refund = props => <PayoutWorkspace mode="refund" {...props} />;
export default Refund;
